export const PdfViewerPreset = {
    developer: "developer",
    viewer: "viewer"
} as const;

export type PdfViewerPreset = typeof PdfViewerPreset[keyof typeof PdfViewerPreset];
